import Main from './schedule/main.es6';

const main = new Main();
